// frontend/src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// Importamos las traducciones directamente
import translationEN from './locales/EN/translation.json';
import translationES from './locales/ES/translation.json';

// Recursos de traducción
const resources = {
	EN: {
		translation: translationEN,
	},
	ES: {
		translation: translationES,
	},
};

// Inicializar i18n
i18n
	.use(Backend)
	.use(initReactI18next)
	.init({
		resources,
		lng: 'ES', // Idioma por defecto
		fallbackLng: 'ES',
		debug: false, // ✅ Desactivar debug para evitar warnings innecesarios
		// ✅ NO usar returnObjects global - solo cuando sea necesario en cada llamada

		interpolation: {
			escapeValue: false, // React ya evita los ataques XSS
		},

		react: {
			useSuspense: false, // Para evitar problemas con componentes suspendidos
		},
	});

// Función para cambiar el idioma
export const changeLanguage = (language) => {
	i18n.changeLanguage(language);
};

// Exportar i18n (nota: es la instancia configurada, no un re-export desde otro módulo)
// NOSONAR: No es un re-export, es la instancia configurada en este archivo
export default i18n; // NOSONAR
